import { Log } from 'ng2-logger';
import React, { Children, Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import * as Actions from '../../../../../store/actions/examSession';
import { GetExamPopulatePurge } from '../../../../../store/actions/background';
import { IPublishDatas } from '../../../../../models/components/add-exam-sessions';
import { DatetimeFormik } from '../../../../../components/input/date-time/date-time-formik';
import { Formik, FormikContext, FormikProps } from 'formik';
import Moment from 'moment';
import { IExamSessionData, IExamSessionList, ISelectedExamSession } from '../../../../../models/action/examSession';
import { getValidation } from '../../../../../models/validations/activity-exam-session-add-validation';
import { Common } from '../../../../../core/common';
import { IPreference } from '../../../../../models/action/profile';
import { Confirm, Notification } from '../../../../../components/notification/main';
import { ILessonPageClassInformation } from '../../../../../models/pages/coursePage';
import ICourseContentTermWeeks from '../../../../../models/components/course-content-termweeks';
import { ExamScoringType } from '../../../../../models/enums/ExamScoringType';
import { ExamPublisingTabTypes, DefineDefaultTab } from '../../../../../models/enums/ExamPublisingTabType';
import { IExamData } from '../../../../../models/action/exam';
import { Button } from '../../../../../components/ui-elements/main';
interface IPublishingProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    dispatch?: any;
    publishDatas?: IPublishDatas;
    changeTab: (tabName: string) => void;
    sessionList?: IExamSessionList[];
    userPreferences?: IPreference[];
    updateActivityId?: string;
    coursePageclassInformation?: ILessonPageClassInformation | null;
    courseContentTermWeeks?: ICourseContentTermWeeks[] | null;
    setExamSessionId: (examSessionId: string) => void;
    examSessionData?: IExamSessionData;
    formik: FormikContext<IExamData>;
    selectedExamSession?: ISelectedExamSession;
    setCloseModal: (examSessionId: string, currentTab: string) => void;
}

interface IPublishingState {
    isPublishing: boolean;
    currentTab: string;
    tabList: string;
}

const T = Translator.create();
const _logger = Log.create('Add Session Publishing');
let _common: Common;
export class Publishing extends Component<IPublishingProps, IPublishingState> {

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.state = {
            isPublishing: false,
            currentTab: '_sessionProperties',
            tabList: ''
        };
    }

    componentDidMount = () => {
        this.getPublishingDatas();
    };

    componentDidUpdate(prevProps: Readonly<IPublishingProps>, prevState: Readonly<IPublishingState>, snapshot?: any): void {
        if (prevProps.currentTab !== this.props.currentTab && this.props) {
            this.setState({
                ...this.state,
                tabList: DefineDefaultTab(this.props),
            });
        }
        else if (prevProps.publishDatas !== this.props.publishDatas) {
            if (this.props.examSessionId && this.props.publishDatas && this.props.publishDatas.isQuestionGraterThanZero && this.props.publishDatas.isSessionQuestionCountGraterEqualThanExamQuestionCount &&
                this.props.publishDatas.isValidSessionDates && this.props.publishDatas.sessionEndDateIsNotExpired && this.props.publishDatas.isStudentGraterThanZero &&
                this.props.publishDatas.isWeightingOk) {
                this.props.changeTab('_sessionPublish')
            }
        }
    }

    getPublishingDatas = () => {
        if (this.props.examSessionId && this.props.examId) {
            this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
        }
    };
    getValidation = () => {
        if (
            this.props.coursePageclassInformation &&
            this.props.coursePageclassInformation.isWeekly === true &&
            this.props.coursePageclassInformation.startDate &&
            this.props.coursePageclassInformation.endDate
        ) {
            return getValidation({
                isProjectSubActivity: false,
                startDate: this.props.coursePageclassInformation.startDate,
                endDate: this.props.coursePageclassInformation.endDate,
                dateFormat: _common.findDateFormat(this.props.userPreferences!),
                termWeeks: this.props.courseContentTermWeeks,
                isUpdate: this.props.examSessionId ? true : false
            });
        } else {
            return getValidation({ isProjectSubActivity: false });
        }
    };
    getPublish = (isPublish: boolean) => {
        if (this.props.examSessionId && this.props.examId && !this.state.isPublishing) {
            this.setState({ isPublishing: true });
            if (isPublish) {
                Notification.setNotification('success', T.t('r_gen_exam_session_publish_notification'), 'topRight');
                this.props.dispatch(Actions.ExamSessionPublish(this.props.examSessionId, this.props.examId, this.props.selectedExamSession!.examSessionBeginDate!, this.props.selectedExamSession!.examSessionEndDate!, this.getPublishCallBack, '', 'get'));
            }
            else {
                this.props.dispatch(GetExamPopulatePurge(this.props.examSessionId, 'getExamPopulatePurge', 'get', this.getExamPopulatePurgeCallBack));

            }
        }
    }
    // public onClickDeleteFile = () => {
    //     Confirm.setConfirm('checkControl', () => this.onCloseModal(), T.t('r_close_session_modal'), null);
    // };
    onCloseModal = () => {
        this.props.dispatch(Actions.ExamSessionSetUpdateDefault());
        this.props.dispatch(Actions.ExamSessionAddStudentListDefault());

        this.props.setCloseModal('', '');
        this.setState({
            currentTab: '_sessionProperties'
        });
    };

    getPublishCallBack = () => {
        setTimeout(() => {
            this.getPublishingDatas();
            this.onCloseModal();
            this.setState({ isPublishing: false });

        }, 50);
    }

    getExamPopulatePurgeCallBack = () => {
        setTimeout(() => {
            if (this.props.examSessionId && this.props.examId) {
                this.props.dispatch(Actions.ExamSessionUnpublish(this.props.examSessionId, this.props.examId, this.props.selectedExamSession!.examSessionBeginDate!, this.props.selectedExamSession!.examSessionEndDate!, this.getPublishCallBack, '', 'get'))
            }

        }, 50);
    }

    showTab = (ExamPublisingTabTypes: any) => {
        this.setState({
            ...this.state,
            tabList: ExamPublisingTabTypes,
        });
    };


    renderPublishContent = (
        isPublished: boolean,
        isPublishable: boolean,
        publishTextKey: string,
        explainTextKey: string,
        buttonType: 'primary' | 'danger',
        buttonTextKey: string,
        icon: string,
        onClickHandler: () => void
    ) => {
        return (
            <>
                <span className="error_text">{T.t(publishTextKey)}</span>
                <span className="small_error_text">{T.t(explainTextKey)}</span>
                <Button
                    button_type={buttonType}
                    size="medium"
                    onClick={onClickHandler}
                    text={T.t(buttonTextKey)}
                    iconPosition="left"
                    materialicon={icon}
                />
            </>
        );
    };

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);

        const examSessionBeginDate =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionBeginDate
                ? Moment(this.props.selectedExamSession.examSessionBeginDate.toString())
                    .format(userDateFormat)
                    .toString()
                : '';
        const examSessionBeginDateTime =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionBeginDate
                ? Moment(this.props.selectedExamSession.examSessionBeginDate.toString())
                    .format(window.appSettings.DefaultDateTimeFormat)
                    .toString()
                : '';
        const examSessionEndDate =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionEndDate
                ? Moment(this.props.selectedExamSession.examSessionEndDate.toString())
                    .format(userDateFormat)
                    .toString()
                : '';
        const examSessionEndDateTime =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionEndDate
                ? Moment(this.props.selectedExamSession.examSessionEndDate.toString())
                    .format(window.appSettings.DefaultDateTimeFormat)
                    .toString()
                : '';

        if (this.state.tabList === '' && this.props.currentTab === '_sessionPublish') {
            this.setState({
                ...this.state,
                tabList: DefineDefaultTab(this.props),
            });
        }


        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionPublish' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-3" style={{ height: 'fit-content', paddingLeft: 15 }}>
                            <div
                                className="nav flex-column nav-pills session_publish"
                                id="v-pills-tab"
                                role="tablist"
                                aria-orientation="vertical"
                            >
                                {/* oturuma en az 1  soru sayısı eklenmeli */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isQuestionGraterThanZero ? 'success' : 'wrong'
                                    )}
                                    id="v-pills-1"
                                    data-toggle="pill"
                                    href="#v-pills-t1"
                                    role="tab"
                                    aria-controls="v-pills-home"
                                    aria-selected="true"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.isQuestionGraterThanZero)}
                                >
                                    {T.t('r_gen_exam_session_publishing_questionCountGraterThanZero')}
                                </a>

                                {/* oturumdaki soru sayısı eşit veya daha fazla */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas &&
                                            this.props.publishDatas.isSessionQuestionCountGraterEqualThanExamQuestionCount
                                            ? 'success'
                                            : 'wrong'
                                    )}
                                    id="v-pills-2"
                                    data-toggle="pill"
                                    href="#v-pills-t2"
                                    role="tab"
                                    aria-controls="v-pills-settings"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.isSessionQuestionCountGraterEqualThanExamQuestionCount)}
                                >
                                    {T.t('r_gen_exam_session_isSessionQuestionCountGraterEqualThanExamQuestionCount')}
                                </a>

                                {/* oturuma başlangıç bitiş tarihi */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isValidSessionDates ? 'success' : 'wrong'
                                    )}
                                    id="v-pills-3"
                                    data-toggle="pill"
                                    href="#v-pills-t3"
                                    role="tab"
                                    aria-controls="v-pills-profile"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.isValidSessionDates)}
                                >
                                    {T.t('r_gen_exam_session_publishing_startEndDates')}
                                </a>

                                {/* oturum bitiş tarihi geçmiş mi */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas && this.props.publishDatas.sessionEndDateIsNotExpired ? 'success' : 'wrong'
                                    )}
                                    id="v-pills-4"
                                    data-toggle="pill"
                                    href="#v-pills-t4"
                                    role="tab"
                                    aria-controls="v-pills-profile"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.sessionEndDateIsNotExpired)}
                                >
                                    {T.t('r_gen_exam_session_publishing_endDate')}
                                </a>

                                {/* oturuma en az 1 öğrenci ekli olmalı */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isStudentGraterThanZero ? 'success' : 'wrong'
                                    )}
                                    id="v-pills-5"
                                    data-toggle="pill"
                                    href="#v-pills-t5"
                                    role="tab"
                                    aria-controls="v-pills-profile"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.isStudentGraterThanZero)}
                                >
                                    {T.t('r_gen_exam_session_isStudentGraterThanZero')}
                                </a>

                                {/* ssoru not ağırlığı */}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isWeightingOk ? 'success' : 'wrong'
                                    )}
                                    id="v-pills-6"
                                    data-toggle="pill"
                                    href="#v-pills-t6"
                                    role="tab"
                                    aria-controls="v-pills-profile"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.isWeightingOk)}
                                >
                                    {T.t('r_gen_exam_publishing_questionWeight')}
                                </a>

                                {/* ön atama*/}
                                <a
                                    className={'nav-link '.concat(
                                        this.props.publishDatas
                                            ? this.props.publishDatas.prePopulateCount === this.props.publishDatas.examUserCount
                                                ? 'success'
                                                : 'wrong'
                                            : ''
                                    )}
                                    id="v-pills-7"
                                    data-toggle="pill"
                                    href="#v-pills-t7"
                                    role="tab"
                                    aria-controls="v-pills-profile"
                                    aria-selected="false"
                                    onClick={() => this.showTab(ExamPublisingTabTypes.prePopulateCount)}
                                >
                                    {T.t('r_gen_exam_session_prePopulateCount')}
                                    {this.props.publishDatas
                                        ?
                                        <span> &nbsp; {this.props.publishDatas.prePopulateCount}/{this.props.publishDatas.examUserCount}</span>
                                        : '(0/0)'}
                                </a>
                            </div>
                        </div>

                        <div className="col-9 ">
                            <div className="tab-content pt-0 session_scroll bg-transparent" id="v-pills-tabContent">
                                <div
                                    className={'tab-pane fade '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isQuestionGraterThanZero
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.isQuestionGraterThanZero ? ' active show' : '')}
                                    id="v-pills-t1"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-1"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content">
                                            <img className="error_img" src="./images/error.svg" alt="" />
                                            <span className="error_text">{T.t('r_gen_exam_session_isQuestionGraterThanZero')}</span>
                                            <span className="small_error_text">
                                                {T.t('r_gen_exam_session_isQuestionGraterThanZeroExplain')}
                                            </span>
                                            <Button
                                                button_type='primary'
                                                size='medium'
                                                onClick={this.props.changeTab.bind(this, '_sessionAddQuestion')}
                                                text={T.t('r_gen_exam_session_add_page_questions')}
                                                iconPosition='left'
                                                materialicon='add'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade '.concat(
                                        this.props.publishDatas &&
                                            this.props.publishDatas.isSessionQuestionCountGraterEqualThanExamQuestionCount
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.isSessionQuestionCountGraterEqualThanExamQuestionCount ? ' active show' : '')}
                                    id="v-pills-t2"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-2"
                                >
                                    <div className="row  mt-0">
                                        <div className=" error_content">
                                            <img className="error_img" src="./images/error.svg" alt="" />
                                            <span className="error_text">{T.t('r_gen_exam_session_questions_count')}</span>
                                            <span className="small_error_text">{T.t('r_gen_exam_session_questions_countExplain')}</span>

                                            <Button
                                                button_type='primary'
                                                size='medium'
                                                text={T.t('r_gen_exam_session_add_page_questions')}
                                                iconPosition='left'
                                                onClick={this.props.changeTab.bind(this, '_sessionAddQuestion')}
                                                materialicon='add'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isValidSessionDates
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.isValidSessionDates ? ' active show' : '')}
                                    id="v-pills-t3"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-3"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content w-100">
                                            <span className="error_text">{T.t('r_gen_exam_session_publishing_startEndDates')}</span>
                                            <span className="small_error_text">{T.t('r_gen_exam_session_publishing_startEndDates')}</span>
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-center">
                                                    <div
                                                        className="media session_detail_card  mw-50"
                                                        onClick={this.props.changeTab.bind(this, '_sessionProperties')}
                                                    >
                                                        <div className="media-body d-flex justify-content-start align-items-center">
                                                            <div
                                                                style={{ width: '48px !important', height: '48px !important' }}
                                                                className="session_detail_card_icon start_icon"
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    src={_common.GetDefaultIcons('hourstartlight')}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="d-flex flex-column align-items-start">
                                                                <p style={{ margin: 'auto 0' }}>{T.t('r_activity_begin_date')}</p>
                                                                <h4>
                                                                    {examSessionBeginDate} - {examSessionBeginDateTime}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="session_detail_add_btn">
                                                            <span className="add_btn">
                                                                <i className="material-icons">edit</i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 d-flex justify-content-center">
                                                    <div
                                                        className="media session_detail_card  mw-50"
                                                        onClick={this.props.changeTab.bind(this, '_sessionProperties')}
                                                    >
                                                        <div className="media-body d-flex justify-content-start align-items-center">
                                                            <div
                                                                style={{ width: '48px !important', height: '48px !important' }}
                                                                className="session_detail_card_icon end_icon"
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    src={_common.GetDefaultIcons('hoursendlight')}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="d-flex flex-column align-items-start">
                                                                <p style={{ margin: 'auto 0' }}>{T.t('r_activity_due_date')}</p>
                                                                <h4>
                                                                    {examSessionEndDate} - {examSessionEndDateTime}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="session_detail_add_btn">
                                                            <span className="add_btn">
                                                                <i className="material-icons">edit</i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade  '.concat(
                                        this.props.publishDatas && this.props.publishDatas.sessionEndDateIsNotExpired
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.sessionEndDateIsNotExpired ? ' active show' : '')}
                                    id="v-pills-t4"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-4"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content w-100">
                                            <span className="error_text">{T.t('r_gen_exam_session_publishing_endDate')}</span>
                                            <span className="small_error_text">{T.t('r_gen_exam_session_publishing_endDateExplain')}</span>
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-center">
                                                    <div
                                                        className="media session_detail_card mw-50"
                                                        onClick={this.props.changeTab.bind(this, '_sessionProperties')}
                                                    >
                                                        <div className="media-body d-flex justify-content-start align-items-center">
                                                            <div
                                                                style={{ width: '48px !important', height: '48px !important' }}
                                                                className="session_detail_card_icon end_icon"
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    src={_common.GetDefaultIcons('hoursendlight')}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="d-flex flex-column align-items-start">
                                                                <p style={{ margin: 'auto 0' }}>{T.t('r_activity_due_date')}</p>
                                                                <h4>
                                                                    {examSessionEndDate} - {examSessionEndDateTime}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="session_detail_add_btn">
                                                            <span className="add_btn">
                                                                <i className="material-icons">edit</i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade  '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isStudentGraterThanZero
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.isStudentGraterThanZero ? ' active show' : '')}
                                    id="v-pills-t5"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-5"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content">
                                            <img className="error_img" src="./images/error.svg" alt="" />
                                            <span className="error_text">{T.t('r_gen_exam_session_isStudentGraterThanZeroHead')}</span>
                                            <span className="small_error_text">{T.t('r_gen_exam_session_isStudentGraterThanZeroHeadExplain')}</span>

                                            <Button
                                                button_type='primary'
                                                size='medium'
                                                text={T.t('r_gen_exam_session_publish_student')}
                                                iconPosition='left'
                                                onClick={this.props.changeTab.bind(this, '_sessionStudents')}
                                                materialicon='add'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade  '.concat(
                                        this.props.publishDatas && this.props.publishDatas.isWeightingOk
                                            ? 'session_bg_green'
                                            : 'session_bg_red'
                                    ) + (this.state.tabList === ExamPublisingTabTypes.isWeightingOk ? ' active show' : '')}
                                    id="v-pills-t6"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-6"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content w-100">
                                            <span className="error_text">{T.t('r_gen_exam_publishing_questionWeight')}</span>
                                            <span className="small_error_text">
                                                {T.t('r_gen_exam_publishing_questionWeightExplain')}
                                            </span>
                                            <Button
                                                button_type='primary'
                                                size='medium'
                                                text={T.t('r_gen_exam_session_add_page_questions')}
                                                iconPosition='left'
                                                materialicon='add'
                                                onClick={this.props.changeTab.bind(this, '_sessionAddQuestion')}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={'tab-pane fade  '.concat(
                                        this.props.publishDatas
                                            ? this.props.publishDatas.prePopulateCount === this.props.publishDatas.examUserCount
                                                ? 'session_bg_green'
                                                : 'session_bg_red'
                                            : ''
                                    ) + (this.state.tabList === ExamPublisingTabTypes.prePopulateCount ? '  active show' : '')}
                                    id="v-pills-t7"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-7"
                                >
                                    <div className="row mt-0">
                                        <div className=" error_content">

                                            {this.props.publishDatas ? (
                                                this.props.publishDatas.activeStatus === 1 ? (
                                                    this.renderPublishContent(
                                                        true,
                                                        false,
                                                        'r_gen_exam_session_published',
                                                        'r_gen_exam_session_unpublishExplain',
                                                        'danger',
                                                        'r_gen_exam_session_unpublish',
                                                        'close',
                                                        () => this.getPublish(false)
                                                    )
                                                ) : this.props.publishDatas.isWeightingOk &&
                                                    this.props.publishDatas.isStudentGraterThanZero &&
                                                    this.props.publishDatas.sessionEndDateIsNotExpired &&
                                                    this.props.publishDatas.isValidSessionDates &&
                                                    this.props.publishDatas.isSessionQuestionCountGraterEqualThanExamQuestionCount &&
                                                    this.props.publishDatas.isPassive &&
                                                    this.props.publishDatas.isAvaible &&
                                                    this.props.publishDatas.isQuestionGraterThanZero ? (
                                                    this.renderPublishContent(
                                                        false,
                                                        true,
                                                        'r_gen_exam_session_prePopulateCount',
                                                        'r_gen_exam_session_publishExplain_',
                                                        'primary',
                                                        'r_gen_exam_session_publish_',
                                                        'done',
                                                        () => this.getPublish(true)
                                                    )
                                                ) : (
                                                    this.renderPublishContent(
                                                        false,
                                                        false,
                                                        'r_gen_exam_session_prePopulateCount',
                                                        'r_gen_exam_session_publishExplain_',
                                                        'danger',
                                                        'r_gen_exam_session_not_publish',
                                                        'done',
                                                        () => { }
                                                    )
                                                )
                                            ) : (
                                                this.renderPublishContent(
                                                    false,
                                                    false,
                                                    'r_gen_exam_session_prePopulateCount',
                                                    'r_gen_exam_session_publishExplain_',
                                                    'danger',
                                                    'r_gen_exam_session_not_publish',
                                                    'done',
                                                    () => this.getPublish(false)
                                                )
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IPublishingProps): IPublishingProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IPublishingProps = Object.assign({}, ownProps, {
        selectedExamSession: state.examSession.selectedSession,
        publishDatas: state.examSession.publishDatas,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.examSession.publishDatas === prev.examSession.publishDatas &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CPublishing = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Publishing);

export default CPublishing;
